// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"2689e93c","171":"ff192340","374":"84e2a4ed","429":"5ac6679d","432":"14923c0b","453":"f6779b07","507":"998554bd","696":"502c26c5","923":"9d7fbc87"}[chunkId] + ".chunk.js";
};